import React from 'react'
import ENV from '../../env'
import PropTypes from 'prop-types'

const Language = props => {
  return (
    <React.Fragment>
      <a href={ENV.root_path + '/sr/privatni/'} className="language-link">
        <span className={`list-item first-level ${props.activeLanguage === 'sr' ? 'active' : ''}`} id="srb-language">Srb</span>
      </a>
      <a href={ENV.root_path + '/en/consumer/'} className="language-link">
        <span className={`list-item first-level ${props.activeLanguage === 'en' ? 'active' : ''}`} id="eng-language">Eng</span>
      </a>
    </React.Fragment>
  )
}

Language.propTypes = {
  activeLanguage: PropTypes.string.isRequired
}

export default Language
